import { Check } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormHeader from "../../../components/form/FormHeader";
import { Button } from "../../../components/button";
import { useToast } from "../../../components/toast-container";
import { goBackOrGoHome } from "../../../utils/navigation";
import { useCreateUser } from "../hooks";
import { UserForm, type UserFormValues } from "../components/user-form";

export default function CreateUserPage() {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { createUser, loading, error } = useCreateUser();
  const [values, setValues] = useState<UserFormValues>({ email: "", phone_number: "", password: "" });
  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      await createUser({
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        country_code: values.country_code,
        phone_number: values.phone_number,
        country: values.country,
        zip_code: values.zip_code,
        gender: values.gender,
        date_of_birth: values.date_of_birth,
        language: values.language,
        population_id: values.population_id,
        age: values.age === undefined ? undefined : Number(values.age),
        password: values.password,
      });
      addToast({ type: "success", title: "Success", message: "User created successfully" });
      navigate("/users", { replace: true });
    } catch {
      /* hook exposes error */
    }
  };
  return (
    <div className="min-h-screen bg-background">
      <FormHeader
        onBack={() => goBackOrGoHome(navigate)}
        title="Create user"
        actions={
          <Button type="submit" form="user-create-form" disabled={loading}>
            <Check className="h-4 w-4" />
            Create user
          </Button>
        }
      />
      <UserForm
        formId="user-create-form"
        values={values}
        onChange={setValues}
        onSubmit={submit}
        error={error}
        loading={loading}
        mode="create"
      />
    </div>
  );
}
